import React from 'react'

export default function Video() {
    return (
        <div>
            <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_393_407)">
                    <path d="M22 3.66667C32.109 3.66667 40.3333 11.891 40.3333 22C40.3333 32.109 32.109 40.3333 22 40.3333C11.891 40.3333 3.66667 32.109 3.66667 22C3.66667 11.891 11.891 3.66667 22 3.66667ZM22 0C9.8505 0 0 9.8505 0 22C0 34.1495 9.8505 44 22 44C34.1495 44 44 34.1495 44 22C44 9.8505 34.1495 0 22 0ZM16.5 31.1667V12.8333L33 22.2677L16.5 31.1667Z" fill="black" />
                </g>
                <defs>
                    <clipPath id="clip0_393_407">
                        <rect width="44" height="44" fill="white" />
                    </clipPath>
                </defs>
            </svg>

        </div>
    )
}
